export default __webpack_public_path__ + "static/Packaging_1-59ca5803ba4e28f7765be08eb5e6d409.jpg";